import { ColumnDef } from "@tanstack/react-table";
import { Event } from "@/endpoints/dryp/event";
import { NumberColumn } from "@/components/tableColumns/NumberColumn";
import { ExpandedChildExport, ExpandedChildExportRow } from "@/types/list";
import get from "lodash.get";
import { DurationColumn } from "@/components/tableColumns/DurationColumn";
import { BooleanColumn } from "@/components/tableColumns/BooleanColumn";
import { DateTimeColumn } from "@/components/tableColumns/DateTimeColumn";

const config = {
	enableSorting: false,
	meta: {
		headerClassName: "bg-indigo-200",
		cellClassName: "bg-indigo-50",
	},
};
export const EventColumns: ColumnDef<Event>[] = [
	NumberColumn<Event>({
		...config,
		accessorKey: "PointId.trimRight",
		id: "rainAccumulation.value",
		header: "Rain",
		align: "left",
		d3Format: ".2f",
		meta: {
			unit: "m",
			...config.meta,
		},
	}),
	NumberColumn<Event>({
		...config,
		accessorKey: "PointId",
		id: "overflow.value",
		header: "Volume",
		align: "left",
		d3Format: ".2f",
		meta: {
			unit: "m3",
			...config.meta,
		},
	}),
	DurationColumn({
		...config,
		accessorKey: "DurationInSeconds",
		header: "Duration",
		align: "left",
		durationClassName: "text-sm text-muted-foreground",
	}),
	DateTimeColumn({
		...config,
		accessorKey: "Start",
		id: "Start",
		header: "Event start",
		format: "dd LLL yyyy, HH:mm",
		align: "left",
		datetimeClassName: "text-sm",
	}),
	BooleanColumn({
		...config,
		header: "Valid",
		accessorKey: "IsEventDataValidated",
		id: "IsEventDataValidated",
		align: "left",
	}),
];

export const getEventExportData = (events: Event[]): ExpandedChildExport => {
	const headers = EventColumns.map(col => {
		return typeof col.header === "string" ? col.header : String(col.id ?? "");
	});

	const rows: ExpandedChildExportRow[] = events.map(row => {
		const formatted: ExpandedChildExportRow = {};

		EventColumns.forEach(col => {
			const colId = col.id ?? (col as any).accessorKey;
			if (!colId) return;

			const value = get(row, colId as string);
			const formatFn = col.meta?.exportFormat;
			const label = typeof col.header === "string" ? col.header : String(colId);

			formatted[label] = formatFn ? formatFn(value, row) : value;
		});

		return formatted;
	});

	return { headers, rows };
};
